import { cn } from '@Pages/pageRuntime/lib/utils';
import * as React from 'react';

const Card = ({ className, ref, ...props }: React.ComponentProps<'div'>) => (
  <div
    ref={ref}
    className={cn(
      'rounded-xl bg-card text-card-foreground shadow ring-1 ring-black/5 dark:ring-white/10',
      className
    )}
    {...props}
  />
);
Card.displayName = 'Card';

const CardHeader = ({ className, ref, ...props }: React.ComponentProps<'div'>) => (
  <div ref={ref} className={cn('flex flex-col gap-1.5 p-6', className)} {...props} />
);
CardHeader.displayName = 'CardHeader';

const CardTitle = ({ className, ref, ...props }: React.ComponentProps<'div'>) => (
  <div
    ref={ref}
    className={cn('leading-none font-semibold tracking-tight', className)}
    {...props}
  />
);
CardTitle.displayName = 'CardTitle';

const CardDescription = ({ className, ref, ...props }: React.ComponentProps<'div'>) => (
  <div ref={ref} className={cn('text-sm text-muted-foreground', className)} {...props} />
);
CardDescription.displayName = 'CardDescription';

const CardPageHeader = ({
  title,
  description,
  actions
}: {
  title: React.ReactNode;
  description?: React.ReactNode;
  actions?: React.ReactNode;
}) => (
  <CardHeader className="grid grid-cols-[minmax(0,1fr)] gap-x-4 gap-y-1.5 sm:grid-cols-[minmax(0,1fr)_auto]">
    <CardTitle className="flex min-h-9 items-center">
      <h2>{title}</h2>
    </CardTitle>
    {description ? (
      <CardDescription className="row-start-2 sm:col-span-2">{description}</CardDescription>
    ) : null}
    {actions ? (
      <div className="flex flex-wrap items-center gap-2 pt-2 sm:col-start-2 sm:row-start-1 sm:justify-end sm:pt-0">
        {actions}
      </div>
    ) : null}
  </CardHeader>
);
CardPageHeader.displayName = 'CardPageHeader';

const CardContent = ({ className, ref, ...props }: React.ComponentProps<'div'>) => (
  <div ref={ref} className={cn('p-6 pt-0', className)} {...props} />
);
CardContent.displayName = 'CardContent';

const CardFooter = ({ className, ref, ...props }: React.ComponentProps<'div'>) => (
  <div ref={ref} className={cn('flex items-center p-6 pt-0', className)} {...props} />
);
CardFooter.displayName = 'CardFooter';

export { Card, CardContent, CardDescription, CardFooter, CardHeader, CardPageHeader, CardTitle };
